<template>
  <div>
    <section class="banner-area">
      <el-carousel :interval="5000" style="width: 100%; z-index: 1;" trigger="click" height="70vh">
        <el-carousel-item v-for="(item, index) in list.position1" :key="index" v-show="list.position1.length>0">
<!--          <img :src="item.thumb" style="width: 100%; height: 100%;" />-->
          <div class="banner-area-img" :style="{ width: '100%', height: '100%', 'background-image': 'url('+item.thumb+')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%' }" ></div>
          <div class="new-banner-text" >
            <div class="new-banner-title">
              <span style="display: block;" >{{ item.title }}</span>
              <span style="display: block;">{{ item.brief }}</span>
            </div>
<!--            <el-button round style="color: #0068b7">了解更多</el-button>-->

            <div class="new-banner-brief" v-if="item.content != null" v-html="item.content"></div>
          </div>

        </el-carousel-item>
      </el-carousel>
    </section>

    <section class="banner-area" v-if="list.position2.length>0">
      <div class="banner-item">
        <div class="row max-height">
          <div class="col-lg-3  offset-xl-1 align-self-center">
            <div class="banner-about color-content">
              <h2 class="color-title" >Solution</h2>
              <h2  class="color-title">解决方案</h2>
              <b class="slot-about"></b>
              <p v-if="list.position2.length>0" class="py-3">{{ list.position2[0].brief }}</p>
              <el-button v-if="list.position2.length>0" round style="background-color: #232126; color: #FFFFFF; border: 1px solid #999999"  @click="detailClick(list.position2[0].id)">查看更多</el-button>
            </div>
          </div>
          <div class="col-lg-8 px-5">
            <div class="row">
              <div class="col-lg-5  align-self-center" v-if="list.position2.length>1"  @click="detailClick(list.position2[1].id)">
                <div class="single-feature mb-4 mb-lg-0 chengshi1" style="padding: 0px;position: relative;" >
                  <img style="width:100%;height:26vh" :src="list.position2[1].thumb" />
                  <div class="plan-content position2">
                    <h4 class="color-about-foot" style="font-size:2vh">{{ list.position2[1].title }}</h4>
                    <p class="color-about-foot " style="font-size:1.5vh;width: 95%;">{{ list.position2[1].brief }}</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-5  align-self-center" v-if="list.position2.length>2"  @click="detailClick(list.position2[2].id)">
                <div class="single-feature mb-4 mb-lg-0 chengshi1" style="padding: 0px;position: relative;" >
                  <img style="width:100%;height:26vh" :src="list.position2[2].thumb" />
                  <div class="plan-content position2">
                    <h4 class="color-about-foot" style="font-size:2vh">{{ list.position2[2].title }}</h4>
                    <p class="color-about-foot " style="font-size:1.5vh;width: 95%;">{{ list.position2[2].brief }}</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-5  align-self-center" v-if="list.position2.length>3"  @click="detailClick(list.position2[3].id)">
                <div class="single-feature mb-4 mb-lg-0 chengshi1" style="padding: 0px;position: relative;" >
                  <img style="width:100%;height:26vh" :src="list.position2[3].thumb" />
                  <div class="plan-content position2">
                    <h4 class="color-about-foot" style="font-size:2vh">{{ list.position2[3].title }}</h4>
                    <p class="color-about-foot " style="font-size:1.5vh;width: 95%;">{{ list.position2[3].brief }}</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-5  align-self-center" v-if="list.position2.length>4"  @click="detailClick(list.position2[4].id)">
                <div class="single-feature mb-4 mb-lg-0 chengshi1" style="padding: 0px;position: relative;" >
                  <img style="width:100%;height:26vh" :src="list.position2[4].thumb" />
                  <div class="plan-content position2">
                    <h4 class="color-about-foot" style="font-size:2vh">{{ list.position2[4].title }}</h4>
                    <p class="color-about-foot " style="font-size:1.5vh;width: 95%;">{{ list.position2[4].brief }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="banner-area" v-if="list.position3.length>0">
      <div class="banner-three" >
        <div class="banner-compony-layout">
         <h3 style="font-size: 3vh; color: #fff;font-style:italic;">{{ list.position3[0].title }}</h3>
          <div class="col-lg-6  align-self-center">
            <div class="single-feature mb-4 mb-lg-0 banner-compony-content">
              <p style="padding: 10px;text-indent:2em;">{{ list.position3[0].brief }} </p>
              <p></p>
              <a href="#" class="secondary-btn color-about">
                <span class="flaticon-next" ></span>
              </a>
            </div>
          </div>
          <div class="col-lg-6 offset-xl-6 align-self-center">
            <div class="single-feature mb-4 mb-lg-0 chengshi2" style="height: 35vh;">
              <img style="width:100%;height:100%;" :src="list.position3[0].thumb" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="banner-area" v-if="list.position4.length>0">
      <div class="banner-four top_img">
        <img style="width: 100%;" :src="list.position4[0].thumb" />
      </div>
    </section>

  </div>
</template>
<script>
import { us } from '@/api/index'

export default {
  props: ['list','menuList'],
  data() {
    return {
      http: window.location.href
    }
  },
  mounted() {

  },
  methods: {
    detailClick(id){
      // this.$router.push({
      //   path: '/detail',
      //   query:{
      //     id:id
      //   }
      // })
    },
    async getus(id) {
      us({ id: id }).then(res => {
        this.list = res.data;
      })
    }
  },
}
</script>
<style scoped>
.new-banner-text {
  position: absolute;
  top: 35vh;
  font-size: 2rem;
  left: 15vw;
  color: #FFFFFF;
  width: 70vw;
  padding-left: 70px;
  /*border: 1px solid red;*/
}
.new-banner-title {
  float: left;
  white-space: pre-line;
  width: 28vw;
  /*background: rgba(0, 0, 0, 0.5);*/
  /*padding: 10px;*/
  /*border-radius: 10px;*/
}
.new-banner-title span:last-child{
  text-indent: 5em;
}
.new-banner-brief {
  /*position: absolute;*/
  /*top: 40vh;*/
  /*right: 15vw;*/
  float: right;
  color: #fff;
  width: 40vw;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 10px;
  line-height: 1;
}
.banner-item {
  height: 100vh;
  background-color: #232126;
}
.banner-three {
  /*height: 100vh;*/
  background: url('/static/assets/images/zay/shouye_bg.png') no-repeat;
  background-size: 100% 100%;
}
.banner-four {
  /*height: 100vh;*/
  /* background: url('/static/assets/images/zay/banner-bg4.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%; */
}
.color-content {
  color: #999999;
}
.color-title {
  color: #FFFFFF;
  margin-bottom: 2vh;
}
.slot-about {
  width: 4rem;
  height: 0.4rem;
  display: block;
  overflow: hidden;
  background-color: #FFFFFF;
  border-radius: 3px;
  left: 0px;
  bottom: 0px;
  top: 45px;
}
.color-about-foot {
  color: #FFFFFF;
}

.single-feature {
  /* padding: 30px; */
  height: 26vh;
}

.chengshi1>img {
  /* background: url('/static/assets/images/banner-bg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%; */
    background: rgba(0, 0, 0, 0.9);

}

/* .chengshi2 {
    background: url('/static/assets/images/zay/组5.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  } */
.row {
  height: 100%;
  margin-left: 0;
  margin-right: 0;
}

.max-height {
  height: 100%
}

.plan-content {
    position: absolute;
    bottom: 0px;
    width: 100%;
    display: flex;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    justify-content: flex-end;
}
.position2>h4 {
  /* text-indent:.5em; */
  margin: 0 10px;

}
.position2>p {
  /* text-indent:.8em; */
  /* margin-left: .8rm; */
  margin: 0 10px;
  margin-bottom: 10px;
}

.banner-compony-layout {
  height: 100%;
  padding: 8vh 13vw 10vh 13vw;
}

.banner-compony-title {
  color: #FFF;
  font-size: 2rem;
  margin-bottom: 1rem;
}

.banner-compony-content {
  background-color: #D3AA5B;
  /* height: 35vh; */
  height: 100%;
  color: #FFF;
  font-size: .9vw
}
.align-self-center{
  padding: 10px;
  /* background: rgba(0, 0, 0, 0.5); */
}
.col-lg-6 {
  padding: 0;
}

@media (max-width: 991.98px) {
  .color-content {
    color: #999999;
    text-align: center;
    padding: 20px 0;
  }

  .slot-about {
    display: none;
  }

  .max-height {
    height: auto;
  }

  .banner-item {
    height: auto;
  }

  .banner-compony-layout {
    padding: 8vh 5vw 5vh 5vw;
  }

  .banner-compony-content {
    font-size: 2vw
  }
}

.row{
  align-content: center;
}
@media (min-width: 991.98px) {
  .offset-xl-6 {
    margin-left: 50%;
  }
}
@media (min-width: 280px) and (max-width: 768px){
  .banner-four{
    /*height: 38vh;*/
  }
  .top_img>img{
    height: 38vh;
  }
}
@media (min-width: 1200px){
  .banner-four{
    width: 100%;
    /*height: 100vh;*/
  }
  .top_img>img{
    height: 100vh;
  }
}

  /*超小屏幕 小屏幕*/
  @media (max-width: 768px) {
    .banner-area-img {
      /*height: 40vh!important;*/
      background-image: url("/static/assets/images/m1px01.png")!important;
      background-repeat: repeat!important;
      background-size: 100% 100%!important;
    }
    .new-banner-text {
      top: 30vh;
      padding: 10px;
      width: auto;
      left: unset;
    }
    .new-banner-title {
      float: none;
      width: 100%;
    }
    .new-banner-title span:first-child{
      font-size: 24px;
    }
    .new-banner-title span:last-child{
      font-size: 18px;
    }
    .new-banner-brief{
      float: none;
      width: auto;
      margin-top: 10px;
      /*background: none;*/
    }
    .el-carousel__container{
      height: 120vh!important;
    }
  }
  /*中屏幕*/
  @media (min-width: 768px) and (max-width: 992px) {
    .banner-area img {
      /*height: 60vh!important;*/
    }
    .new-banner-brief{

    }
  }
  /*大屏幕 超大屏幕*/
  @media (min-width: 992px) {

  }
</style>




// WEBPACK FOOTER //
// new-home.vue?80423a28